const pad = (value: number): string => String(value).padStart(2, "0");

// Время матча в секундах → «8:03» или «1:02:03». Формат одинаков на всех языках.
export const formatGameTime = (seconds: number): string => {
  const total = Math.max(0, Math.round(seconds));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const rest = total % 60;
  return hours > 0 ? `${hours}:${pad(minutes)}:${pad(rest)}` : `${minutes}:${pad(rest)}`;
};
